var _defs, _rect, _g, _rect2, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSopaLetrasPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow-board",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 5,
    stdDeviation: 3,
    floodColor: "#0284C7",
    floodOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow-lens",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 3,
    dy: 6,
    stdDeviation: 4,
    floodColor: "#0F172A",
    floodOpacity: 0.35
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0284C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0369A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "highlightGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#38BDF8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0284C7",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "metalGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#94A3B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B45309"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 100,
    height: 100,
    rx: 16,
    fill: "url(#bgGrad)",
    filter: "url(#shadow-board)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 14,
    x2: 33,
    y2: 106,
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 14,
    x2: 56,
    y2: 106,
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79,
    y1: 14,
    x2: 79,
    y2: 106,
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 33,
    x2: 106,
    y2: 33,
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 56,
    x2: 106,
    y2: 56,
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 79,
    x2: 106,
    y2: 79,
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 86,
    height: 26,
    rx: 13,
    fill: "url(#highlightGrad)",
    stroke: "#38BDF8",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 14,
    fontWeight: 900,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 35
  }, "M"), /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 35
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 35
  }, "Z"), /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 35,
    fill: "#E0F2FE"
  }, "A"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#E0F2FE",
    opacity: 0.8,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 56
  }, "J"), /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 56
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 56
  }, "T"), /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 56
  }, "R"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#E0F2FE",
    opacity: 0.8,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 78
  }, "J"), /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 78
  }, "O"), /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 78
  }, "K"), /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 78
  }, "L"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#E0F2FE",
    opacity: 0.8,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 99
  }, "X"), /*#__PURE__*/React.createElement("text", {
    x: 51,
    y: 99
  }, "H"), /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 99
  }, "U"), /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 99
  }, "B"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(74, 30)",
    filter: "url(#shadow-lens)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12,12 L 28,28",
    stroke: "url(#goldGrad)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,12 L 28,28",
    stroke: "#F59E0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 16,
    fill: "none",
    stroke: "url(#metalGrad)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 14,
    fill: "#38BDF8",
    fillOpacity: 0.25,
    stroke: "#FFFFFF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -9,-6 A 11 11 0 0 1 6,-9",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSopaLetrasPremium);
export default __webpack_public_path__ + "static/media/sopa_letras_premium.a540aa2aa8c60bbdc3320d1cb2b97ca0.svg";
export { ForwardRef as ReactComponent };